import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import LoginPage from './login/LoginPage'
import RegisterUserPage from './register-user/RegisterUserPage'
import ConfirmUserPage from './confirm-user/ConfirmUserPage'
import Dashboard from './dashboard/Dashboard'
import PublicOnlyRoute from './routes/PublicOnlyRoute'
import ProtectedRoute from './routes/ProtectedRoute'
import ForgotPasswordPage from './forgot-password/ForgotPasswordPage'
import NotificationManager from './NotificationManager'
import { inject } from 'mobx-react'

const App = inject('userStore')(withRouter(observer((props) => {
  const { isAuthenticated } = props.userStore.state
  return (
    <React.Fragment>
      <NotificationManager />
      <Switch>
        <PublicOnlyRoute exact path='/' isAuthenticated={isAuthenticated} render={() => <LoginPage />} />
        <PublicOnlyRoute exact path='/cadastrar-usuario' isAuthenticated={isAuthenticated} render={() => <RegisterUserPage />} />
        <PublicOnlyRoute exact path='/confirmar-usuario' isAuthenticated={isAuthenticated} render={() => <ConfirmUserPage />} />
        <PublicOnlyRoute exact path='/esqueci-minha-senha' isAuthenticated={isAuthenticated} render={() => <ForgotPasswordPage />} />
        {/* <PublicOnlyRoute exact path='/solicitar-token' isAuthenticated={isAuthenticated} render={() => <RequestTokenPage />} /> */}

        <ProtectedRoute path='/dashboard' isAuthenticated={isAuthenticated} render={() => <Dashboard />} />
        <Route render={() => <div>404 not found</div>} />
      </Switch>
    </React.Fragment>
  )
})))

export default App



// WEBPACK FOOTER //
// ./src/components/App.js